module.exports = __webpack_public_path__ + "media/images/icon-z-chan-animation-32b63cfc1c595b1e5e3e223e22acfdd5.png";